import { useState } from "react";
import { trpc } from "@/lib/trpc";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatInstalledPower, parseInstalledPowerInput, INSTALLED_POWER_ERROR } from "../../../../shared/installedPower";

/** Technical metadata only; deliberately separate from name and economics. */
export function InstalledPower({ installation, canEdit }: {
  installation: { id: number; installedPowerKwp?: string | number | null };
  canEdit: boolean;
}) {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState("");
  const [error, setError] = useState<string | null>(null);
  const utils = trpc.useUtils();
  const update = trpc.installations.update.useMutation();
  async function save() {
    let power: string | null;
    try { power = parseInstalledPowerInput(value); }
    catch { setError(INSTALLED_POWER_ERROR); return; }
    setError(null);
    try {
      await update.mutateAsync({ id: installation.id, installedPowerKwp: power });
      await utils.installations.invalidate();
      setEditing(false);
    } catch { setError("No se pudo guardar la potencia instalada. Inténtalo de nuevo."); }
  }
  return <div className="space-y-2 text-sm">
    <p className="text-muted-foreground">Potencia instalada DC</p>
    <p>{formatInstalledPower(installation.installedPowerKwp)}</p>
    {canEdit && !editing && <Button size="sm" variant="outline" onClick={() => {
      setValue(installation.installedPowerKwp == null ? "" : String(installation.installedPowerKwp).replace(".", ","));
      setError(null); setEditing(true);
    }}>Editar potencia</Button>}
    {canEdit && editing && <div className="space-y-2">
      <Label htmlFor="installed-power-edit">Potencia instalada DC (kWp)</Label>
      <Input id="installed-power-edit" inputMode="decimal" value={value} disabled={update.isPending} onChange={e => setValue(e.target.value)} aria-describedby="installed-power-help" />
      <p id="installed-power-help" className="text-xs text-muted-foreground">Hasta 3 decimales. Vacío elimina el dato y lo deja sin registrar.</p>
      {error && <p role="alert">{error}</p>}
      <div className="flex flex-wrap gap-2">
        <Button size="sm" disabled={update.isPending} onClick={save}>Guardar potencia</Button>
        <Button size="sm" variant="outline" disabled={update.isPending} onClick={() => setEditing(false)}>Cancelar</Button>
      </div>
    </div>}
  </div>;
}
